import { render, staticRenderFns } from "./ReviewOrdersTable.vue?vue&type=template&id=22d7e4f1&scoped=true"
import script from "./ReviewOrdersTable.vue?vue&type=script&lang=js"
export * from "./ReviewOrdersTable.vue?vue&type=script&lang=js"
import style0 from "./ReviewOrdersTable.vue?vue&type=style&index=0&id=22d7e4f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d7e4f1",
  null
  
)

export default component.exports